import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import "../assets/styles/filesinfo.css";
import { capitalize } from "../common_functions/video_annotator_functions";

const excemptionFields = ["id", "label", "last_timestamp"];

export const FilesInfo = ({ selectedFileInfo, numberType }) => {
  return (
    <TableContainer component={Paper} sx={{ maxWidth: "100%", mt: 2, boxShadow: 3, borderRadius: 2 }}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            <TableCell sx={{ fontWeight: "bold" }}>Attribute</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedFileInfo && Object.keys(selectedFileInfo).length > 0 &&
            Object.entries(selectedFileInfo)
              .filter(([key]) => !excemptionFields.includes(key))
              .map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell>{capitalize(key.replace(/_/g, " "))}</TableCell>
                  <TableCell>
                    {value !== null
                      ? /^[0-9\b]+$/.test(value)
                        ? value.toString() + numberType
                        : value
                      : "N/A"}
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
